// src/styles/antd-custom-theme.js
const theme = {
  token: {
    colorPrimary: "#FFC857", // Set your desired primary color
  },
};

export default theme;
